import { useState, useEffect, ReactElement } from 'react';

import { TimeFormat, TIME_PATTERNS, timeFormatPattern } from '../TimeFormat';

const defaultFormat = `${TIME_PATTERNS.HOURS}:${TIME_PATTERNS.MINUTES} ${TIME_PATTERNS.PERIOD}`;
const UPDATE_INTERVAL = 1000; // ms

type ClockProps = {
  format?: string;
  children?: ({ timeDisplay }: any) => ReactElement;
};

/**
 * Component that displays the client time in hours:minutes AM/PM format
 */
const Clock = ({ format = defaultFormat, children }: ClockProps) => {
  const [ timestamp, setTimestamp ] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimestamp(Date.now());
    }, UPDATE_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return <TimeFormat {...{ timestamp, format }}>{children}</TimeFormat>;
};

Clock.propTypes = {
  format: timeFormatPattern,
};

export default Clock;
